// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xGmW","tabsBox":"styles_tabsBox__9b4aD","createButton":"styles_createButton__363mL"};